import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { SupportedLocale } from '@/lib/env'

interface UiState {
  sidebarCollapsed: boolean
  theme: 'light' | 'dark'
  locale: SupportedLocale
}

const STORAGE_KEY = 'distroops.ui'

function loadInitial(): UiState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) return { ...defaults, ...JSON.parse(raw) }
  } catch {
    /* ignore */
  }
  return defaults
}

const defaults: UiState = {
  sidebarCollapsed: false,
  theme: 'light',
  locale: 'en',
}

const uiSlice = createSlice({
  name: 'ui',
  initialState: loadInitial(),
  reducers: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
      persist(state)
    },
    setTheme(state, action: PayloadAction<'light' | 'dark'>) {
      state.theme = action.payload
      persist(state)
    },
    setLocale(state, action: PayloadAction<SupportedLocale>) {
      state.locale = action.payload
      persist(state)
      document.documentElement.dir = action.payload === 'ar' || action.payload === 'ur' ? 'rtl' : 'ltr'
      document.documentElement.lang = action.payload
    },
  },
})

function persist(state: UiState) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {
    /* ignore */
  }
}

export const { toggleSidebar, setTheme, setLocale } = uiSlice.actions
export default uiSlice.reducer
